import { useQuery } from "@tanstack/react-query";
import { getDashboardCategoryList } from "../../../api/dashboardCategoriesApi";
import { DashboardCategory } from "../../../constants/searchableDashboards";

export const DASHBOARD_CATEGORIES_QUERY_KEY = ["dashboard-categories"];

// GET /dashboards/dashboard_category_list is live (docs/needed-endpoints.md §11) - the
// authoritative list of every category that exists. Read-only: the "Add Category" admin action
// that used to create new categories from the frontend has been removed, so there's no mutation
// here anymore, only this query.
export const useDashboardCategories = () => {
  const { data } = useQuery<DashboardCategory[]>(DASHBOARD_CATEGORIES_QUERY_KEY, getDashboardCategoryList, {
    staleTime: Infinity,
  });
  return { categories: data ?? [] };
};
